<div id="deleted-leaves-view" class="page-layout blank">
    <div class="content">
        <div class="title">
            <h2>Registro de eliminados</h2>
        </div>
        <div class="left">
            <!-- Filters -->
            <div class="view">
                <div class="filters" [formGroup]="form">
                    <div class="each">
                        <mat-label class="label">Usuario</mat-label>
                        <mat-form-field appearance="fill">
                            <mat-select formControlName="abreviacion">
                                <mat-option *ngFor="let option of abreviacions" [value]="option">
                                    {{option}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div> 

                    <div class="each range">
                        <app-date-period-filter [IsBothDatesRequired]="false" [DateType]="DateFilterType.Common"
                            [PeriodFrom]="form.controls.fromDate" [PeriodTo]="form.controls.toDate"
                            (FromDateChanged)="SetFilterValues('commonDateFrom', $event)"
                            (ToDateChanged)="SetFilterValues('commonDateTo', $event)">
                        </app-date-period-filter>
                    </div>

                    <div class="each input">
                        <mat-label class="label">Trabajador</mat-label>
                        <mat-form-field class="example-full-width" appearance="fill">
                            <input matInput formControlName="trabajador">
                        </mat-form-field>
                    </div>

                    <div class="each radiobox">
                        <mat-radio-group aria-label="Select an option" formControlName="tipo">
                            <mat-radio-button value="T">Trabajadores</mat-radio-button>
                            <mat-radio-button value="B">Bajas</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <button mat-raised-button color="primary" (click)="onSearch()">Consultar</button>
            </div>

            <!-- Results -->
            <div class="view">
                <div class="delete-table">
                    <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate"
                        *ngIf="isSearching">
                    </mat-progress-spinner>

                    <table mat-table [dataSource]="searchResults" *ngIf="!isSearching">
                        <caption></caption>
                        <ng-container matColumnDef="fechaEliminacion">
                            <th mat-header-cell *matHeaderCellDef> F. Eliminacion </th>
                            <td mat-cell *matCellDef="let element"> {{element.fechaEliminacion | date:"dd/MM/yyyy"}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="usuario">
                            <th mat-header-cell *matHeaderCellDef> Usuario </th>
                            <td mat-cell *matCellDef="let element"> {{element.usuario}} </td>
                        </ng-container>

                        <ng-container matColumnDef="nomEmp">
                            <th mat-header-cell *matHeaderCellDef> Empresa </th>
                            <td mat-cell *matCellDef="let element"> {{element.nomEmp}} </td>
                        </ng-container>

                        <ng-container matColumnDef="nomTrab">
                            <th mat-header-cell *matHeaderCellDef> Trabajador </th>
                            <td mat-cell *matCellDef="let element"> {{element.nomTrab}} </td>
                        </ng-container>

                        <ng-container matColumnDef="fbaja">
                            <th mat-header-cell *matHeaderCellDef> F.Baja </th>
                            <td mat-cell *matCellDef="let element"> {{element.fbaja | date:"dd/MM/yyyy"}} </td>
                        </ng-container>

                        <ng-container matColumnDef="motivo">
                            <th mat-header-cell *matHeaderCellDef> Motivo </th>
                            <td mat-cell *matCellDef="let element"> {{element.motivo}} </td>
                        </ng-container>

                        <ng-container matColumnDef="recoveryButton">
                            <th mat-header-cell *matHeaderCellDef> </th>
                            <td mat-cell *matCellDef="let element">
                                <button mat-raised-button color="primary"
                                    (click)="onRecover(element)">Recuperar</button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>